import { useCallback, useState } from "react";
import { useAppDispatch } from "../../hook";
import { deleteMessage, flagMessage } from "../conversationSlice";
import { FlagProgressType } from "./types";
export default function useMessageFlagging() {
    const dispatch = useAppDispatch();
    const [progressStep, setProgressStep] = useState(FlagProgressType.SELECT_OPTION);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(false);
    const [success, setSuccess] = useState(false);
    const deleteFlaggedMessage = useCallback(async (args) => {
        const { conversation_id, ids } = args;
        if (conversation_id && ids.length > 0) {
            try {
                await dispatch(deleteMessage(args)).unwrap();
            }
            catch (error) {
                throw error;
            }
        }
    }, []);
    const onFlagMessageHandler = useCallback(async (args) => {
        const { message_id, character_id, label, conversation_id, comment } = args;
        if (message_id && character_id && label) {
            const payload = {
                event_name: "message_report",
                message_id,
                character_id,
                label,
                comment,
            };
            try {
                setIsLoading(true);
                await dispatch(flagMessage(payload)).unwrap();
                await deleteFlaggedMessage({ conversation_id, ids: [message_id] });
                setSuccess(true);
                setProgressStep(FlagProgressType.DONE);
            }
            catch (error) {
                setProgressStep(FlagProgressType.ERROR);
                setError(true);
            }
            finally {
                setIsLoading(false);
            }
        }
    }, []);
    const resetErrorAndSuccess = useCallback(() => {
        setError(false);
        setSuccess(false);
    }, []);
    return {
        onFlagMessageHandler,
        progressStep,
        setProgressStep,
        error,
        success,
        isLoading,
        resetErrorAndSuccess,
    };
}
